/** Tiện ích dùng chung cho module Quản lý thành viên & gói. */

export const nf = (n) => Number(n || 0).toLocaleString('vi-VN');

/** Rút gọn số lớn: 1200 → 1,2k · 1500000 → 1,5tr. */
export const compact = (n) => {
	n = Number(n || 0);
	if (n >= 1e6) return (n / 1e6).toFixed(1).replace(/[.,]0$/, '') + 'tr';
	if (n >= 1e3) return (n / 1e3).toFixed(1).replace(/[.,]0$/, '') + 'k';
	return String(n);
};

/** Màu Tag theo slug gói. */
export const planColor = (slug) => ({
	free: 'default',
	base: 'blue',
	pro: 'purple',
	max: 'gold',
}[slug] || 'cyan');

/** Nhãn + màu Tag theo trạng thái tài khoản. */
export const statusMeta = (status) => ({
	public: {color: 'green', label: 'Hoạt động'},
	block: {color: 'red', label: 'Khóa'},
	suspended: {color: 'orange', label: 'Tạm dừng'},
	pending: {color: 'default', label: 'Chờ duyệt'},
}[status] || {color: 'green', label: 'Hoạt động'});

export const STATUS_OPTIONS = [
	{value: 'public', label: 'Hoạt động'},
	{value: 'block', label: 'Khóa'},
	{value: 'suspended', label: 'Tạm dừng'},
	{value: 'pending', label: 'Chờ duyệt'},
];
